export default {
  NONE: 'NONE',
  EDIT_LABEL: 'EDIT_LABEL',
  EDIT_VALUE: 'EDIT_VALUE'
};